var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cus-g-container cus-pinmycom"},[_c('i',{staticClass:"commicon cus-icon"},[_vm._v("")]),_c('span',[_vm._v("品迈科技")])])
}]

export { render, staticRenderFns }